<template>
  <div class="about">
    <VideoBanner v-if='$route.name === "About"' posterSrc='startsida.jpg' mp4Src='startsida.mp4' webmSrc='startsida.webm' :overlayTitle='$COMPANY.NAME' :overlayDescription='$COMPANY.DESCRIPTION' />
    <div class="main-content small-content">
      <b-container>
        <h2>Om SWE Event &amp; Artist</h2>
        <div class="about-content page-content">
          <b-row>
            <b-col>
              <h3>Vi skapar levande event - med rätt känsla från start till slut</h3>
              <p>På SWE Event & Artist vet vi att ett lyckat event handlar om mer än bara artister eller teknik. Istället handlar det om helheten. Sedan 2017 har vi hjälpt företag och privatpersoner att skapa evenemang som engagerar, underhåller och imponerar.</p>
              <h3>Från idé till färdig upplevelse</h3>
              <p>Vi erbjuder allt du behöver: artister, underhållning, ljud, ljus, scen, teknik och logistiskt stöd. Behöver du bara en enskild tjänst? Inga problem. Vill du ha en helhetslösning? Då tar vi hand om allt med samma höga kvalitet och personliga service.</p>
              <h3>Vi erbjuder:</h3>
              <ul>
                <li>Artistförmedling, från välkända namn till unika upplevelser</li>
                <li>Ljud, ljus och scenteknik för alla typer av evenemang</li>
                <li>Planering och produktion av företagsevent, fester och galor</li>
                <li>Kreativa koncept & underhållningspaket</li>
              </ul>
              <p>Med erfarenhet, passion och ett starkt branschnätverk ser vi till att ditt event känns proffsigt och blir ihågkommet.</p>
              <p class="last-pop">SWE Event & Artist - För dig som vill ha ett event som känns på riktigt.</p>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import VideoBanner from './VideoBanner'

export default {
  components: {
    VideoBanner
  }
}
</script>

<style>
.contact-request {
  font-size: 1.5rem;
}
</style>
